import React from 'react';

/** Friendly empty / error state with an optional action. */
export default function EmptyState({ icon, title, description, action, tone = 'neutral', className = '' }) {
    const chip = tone === 'danger' ? 'bg-danger-bg text-danger-fg' : 'bg-surface-100 text-surface-400';
    return (
        <div className={`flex flex-col items-center justify-center text-center px-6 py-12 ${className}`}>
            {icon && <span className={`mb-4 flex h-12 w-12 items-center justify-center rounded-xl text-xl ${chip}`}>{icon}</span>}
            {title && <div className="text-[15px] font-semibold text-surface-900">{title}</div>}
            {description && <div className="mt-1 max-w-sm text-sm text-surface-500">{description}</div>}
            {action && <div className="mt-5">{action}</div>}
        </div>
    );
}
